export type EducationClaimTelemetryEvent =
  | "tc_claim_benefits_viewed"
  | "tc_claim_benefits_continue_clicked"
  | "tc_claim_homepage_owner_cta_clicked"
  | "tc_claim_page_viewed"
  | "tc_claim_status_loaded"
  | "tc_claim_status_load_failed"
  | "tc_claim_signup_redirected"
  | "tc_claim_submitted"
  | "tc_claim_submit_failed"
  | "tc_claim_verification_sent"
  | "tc_claim_verification_send_failed"
  | "tc_claim_verified"
  | "tc_claim_verify_failed";

export type EducationClaimTelemetryPayload = {
  eventType: EducationClaimTelemetryEvent;
  occurredAtUtc?: string;
  metadata?: Record<string, string | number | boolean | null | undefined>;
};

function normalizeMetadata(metadata?: Record<string, string | number | boolean | null | undefined>) {
  if (!metadata) {
    return undefined;
  }

  return Object.fromEntries(
    Object.entries(metadata)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, value === null ? null : String(value)])
  );
}

export async function trackEducationClaimEvent(
  eventType: EducationClaimTelemetryEvent,
  metadata?: Record<string, string | number | boolean | null | undefined>
) {
  try {
    await fetch("/api/education/telemetry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      keepalive: true,
      body: JSON.stringify({
        eventType,
        occurredAtUtc: new Date().toISOString(),
        metadata: normalizeMetadata(metadata),
      } satisfies EducationClaimTelemetryPayload),
    });
  } catch {
    // Best-effort telemetry only.
  }
}
